export const config = {
  tokenElement: '__RequestVerificationToken',
  tokenKey: '__RequestVerificationToken',
  method: 'POST',
  noTokenFound: '(ignore if not on dotnet) No API token found',
  notOnDotNet: 'You are not running this application in .NET, /gdl/api/ does not work here',
};

export const modules = {
  addresses: '/gdl-api/addresses',
  iban: '/gdl-api/iban',
  permit: '/gdl-api/permit',
  state: '/gdl-api/state',
  orderstate: '/gdl-api/orderstate',
  code: '/gdl-api/code',
};
